import guidedSearchStore from '../guided/guided-search-store';

export const countrySelectorWidgetEventEmitter = (
  isGuidedSearch: boolean,
  hits: number | string,
  guidedSearchEmitter,
  srpEmitter,
  location?: string
) => {
    const gsTerm = guidedSearchStore?.get('gsTerm');
    const currentLocation = new URL(window.location.href)?.searchParams?.get('q');
    const keyword =
    isGuidedSearch && gsTerm
      ? guidedSearchStore?.get('gsTerm') ?? currentLocation
      : currentLocation;

    const source = isGuidedSearch ? 'GuidedSearch' : 'AllResult';
    const type = location ?? 'Select location';
    const eventBody = {
      type,
      keyword,
      source,
      hits,
    };

    isGuidedSearch
      ? guidedSearchEmitter.emit(eventBody)
      : srpEmitter.emit(eventBody);
};
